import type { AssetsLiabilities, FinancialAccount } from "@/types/types";
import Account from "./Account";
import TotalBalance from "./TotalBalance";
import AssetStockInfo from "./AssetStockInfo";

type Props = {
  title?: string | undefined;
  accounts?: FinancialAccount[];
  additionalAssets?: AssetsLiabilities[] | undefined;
  isLifeInsurance?: boolean;
  isNonAssetBal?: boolean;
  assetGroupId?: string;
  assetsTotal: number;
};

export default function Asset({
  title,
  accounts,
  additionalAssets,
  isLifeInsurance = false,
  isNonAssetBal = false,
  assetGroupId,
  assetsTotal,
}: Props) {
  const renderedTickers = new Set<string>();

  return (
    <div className="relative w-full rounded-md border-neutral-500 bg-white p-6 text-neutral-100 shadow-light">
      <div className="flex items-center justify-between gap-2">
        <span className="font-semibold italic underline underline-offset-2 print:text-base">
          {title}
        </span>
        {accounts?.length || additionalAssets?.length ? <TotalBalance value={assetsTotal} /> : null}
      </div>
      {accounts?.length || additionalAssets?.length ? (
        <div className="mt-6 flex flex-col gap-2">
          {accounts?.map((account) => (
            <Account
              account={account}
              key={account.externalCode}
              isLifeInsuranceSection={isLifeInsurance}
              isNonAssetBal={isNonAssetBal}
            />
          ))}
          {additionalAssets?.length
            ? additionalAssets?.map((account) => (
                <Account
                  account={account}
                  key={account.externalCode}
                  isNonAssetBal={isNonAssetBal}
                />
              ))
            : null}
        </div>
      ) : null}
      {accounts?.map((x) => {
        if ((x?.type === "Stock" || x?.type === "Executive Benefit") && x?.ticker)
          if (!renderedTickers.has(x.ticker)) {
            renderedTickers.add(x.ticker);
            return (
              <AssetStockInfo key={x.externalCode} ticker={x.ticker} assetGroupId={assetGroupId} />
            );
          }
        return null;
      })}
    </div>
  );
}
